/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import StationDescriptionTable from '../link/StationDescriptionTable'
import PluviometerDto from '../../../pluviometry/dto/PluviometerDto'

const headers = ['gridType', 'coords', 'area', 'ponderation']

const StationPonderationPanel = ({
    station = {},
    onChange = () => { },
}) => {
    const link_ponds = station?.link_ponds?.map(l => ({ ...l, ponderation: l.pond }))

    return (
        <StationDescriptionTable
            station={{ ...station, link_ponds }}
            readMode={true}
            onChange={onChange}
            keyList='link_ponds'
            formatFunction={c => c}
            titles={{
                title: i18n.gridPonderations,
            }}
            headers={headers}
        />
    )
}

StationPonderationPanel.propTypes = {
    station: PropTypes.instanceOf(PluviometerDto),
    onChange: PropTypes.func,
}

export default StationPonderationPanel